import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ConfigService } from '@core/services';

@Component({
  selector: 'app-page404',
  templateUrl: './page404.component.html',
  styleUrl: './page404.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class Page404Component {
  main_site_url: string;

  constructor(private readonly configService: ConfigService) {
    this.main_site_url = this.configService.postLogoutUri;
  }
}
